import * as React from 'react';
import { AscListContainer } from '../../containers';

const AscListPage: React.FC = () => (
  <AscListContainer />
);

export default AscListPage;
